import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
    return (
        <div className="fixed bottom-0 lg:h-10 leading-10 bg-white border-t border-scogoddd w-full z-40">
            <div className="lg:flex items-center">
                <div className="pl-32"> 
                    <p className="text-scogo21 text-font13 font-normal"><span className="lg:inline-block hidden"> Copyright © 2021 Scogo. All rights received. | </span> Powered by: <Link to="/" className="text-scogoprimary text-font13 font-medium"> Scogo Network</Link></p>
                </div>
                <div className="lg:ml-auto lg:px-5 pl-32 lg:block hidden">
                    <p className="lg:text-right text-scogo21 text-font13 font-normal"><Link to="/">www.customer.superapp.work </Link></p>
                </div>
            </div>
        </div>
    )
}

export default Footer
